// Duration of the collapsibleSx grid-template-rows transition in PartDetails.tsx.
// Inventory.tsx uses this to size FOCUS_LOCK_MS — the window during which a
// layout-induced scroll rebound after collapse must be ignored to avoid the
// "scroll-collapse bounces back open" bug on small data sets.
export const COLLAPSE_TRANSITION_MS = 260;

// Slightly longer than the collapse transition so the rebound clamp from
// AG-Grid resizing after collapse cannot re-fire the unfocus branch. The
// lock is bypassed when the user signals real unfocus intent (an upward
// wheel) — see `lastUnfocusIntentAtRef` in Inventory.tsx. The `+ 140` pad
// is empirical headroom over the 260ms transition.
export const COLLAPSE_FOCUS_LOCK_MS = COLLAPSE_TRANSITION_MS + 140;
